import { useRef } from 'react'
import { useState } from 'react';
import { formatDateToMMDDYYYY, HideLoder, LogInSchoolID, sanitizeCSVField, ShowLoder } from '../../../JS/Common';
import AlertsComp from '../../../Components/AlertsComp';
import { ValidateFile } from '../../../Components/Validations';
import { log } from '../../../JS/Logger';
import { ApiCmnHeadersPostCall, ApiGetCall } from '../../../JS/Connector';
import MultiErrorPopup from '../../../Components/MultiErrorPopup';
import { downloadSampleCSV } from '../../../Helpers/ImpExpHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

export default function UpdateSerialNumber({ FilterData }) {
    const navigate = useNavigate();
    const InventoryRef = useRef();
    const [loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [FileName, setFileName] = useState({
        error: '',
        document: '',
    });
    const [showErrorPopup, setShowErrorPopup] = useState({
        modal: false,
        btn: false
    });
    const [csvError, setCsvError] = useState("");
    const [InventoryDataCsv, setInventoryDataCsv] = useState([]);
    const [divVisibleForExport, setDivVisibleForExport] = useState({
        forUsers: false,
        forUsersNoRecord: false
    });

    async function ImportCSV(e) {
        setShowErrorPopup({ ...showErrorPopup, modal: false, btn: false });
        setLoading(true);
        e.preventDefault();
        const fileInput = InventoryRef.current;
        const files = fileInput.files[0];
        if (!files) {
            setLoading(false)
            setFileName({ ...FileName, error: "First, import the CSV file.", document: "" });
            return;
        }
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...FileName, error: validationMsg, document: '' });
            fileInput.value = "";
            return;
        }

        var formdata = new FormData();
        formdata.append("file", files);
        formdata.append("schoolId", LogInSchoolID);

        try {
            const response = await ApiCmnHeadersPostCall(`/inventory/device-serial-numbers/upload`, formdata);
            const result = response;
            setLoading(false);
            if (result == "success") {
                setNewAlerts(<AlertsComp show={true} variant="success" msg={'CSV imported Successfully'} />);
                setTimeout(function () {
                    navigate('/manage-device');
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000);
            } else {
                const responseRs = JSON.parse(result);
                setCsvError(responseRs);
                setShowErrorPopup({ ...showErrorPopup, modal: true, btn: true });
                setFileName({ ...FileName, error: '', document: '' });
                fileInput.value = "";
            }
            fileInput.value = "";
            setFileName({ ...FileName, error: '', document: '' });
        } catch (error) {
            log.error('error', error);
            fileInput.value = "";
            setFileName({ ...FileName, error: '', document: '' });
        }
    }

    function ShowFileName() {
        const fileInput = InventoryRef.current;
        const files = fileInput.files[0];
        if (!files) return;
        const filename = files.name;
        const { isFileValid, validationMsg } = ValidateFile(files, { allowedType: "csv", maxSizeMB: 25 });
        if (!isFileValid) {
            setFileName({ ...FileName, error: validationMsg, document: '' });
            fileInput.value = "";
            return;
        }
        setFileName({ ...FileName, error: "", document: filename });
    }

    const headers = [
        { label: "Serial Number", key: "serial_number" },
    ];

    const FIELDS_TO_SANITIZE = ['serial_number'];

    function downloadCSV(data) {
        const headerRow = headers.map(h => h.label).join(',');

        const rows = data.map(row =>
            headers.map(h => sanitizeCSVField(h.key, row[h.key], FIELDS_TO_SANITIZE)).join(',')
        );

        const csvContent = [headerRow, ...rows].join('\r\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'DeviceSerialNumbers.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }

    async function ExportInventory() {
        setLoading(true);
        await ApiGetCall(`/inventory/device-serial-numbers/export?schoolId=${LogInSchoolID}&startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.data.length != 0) {
                    setInventoryDataCsv(responseRs.data);
                    setDivVisibleForExport({ ...divVisibleForExport, forUsers: true });
                } else {
                    setInventoryDataCsv([]);
                    setDivVisibleForExport({ ...divVisibleForExport, forUsersNoRecord: true });
                }
                setLoading(false);
            }
        });
    }

    function RemoveUserCsv() {
        setInventoryDataCsv([]);
        setDivVisibleForExport({ ...divVisibleForExport, forUsers: false, forUsersNoRecord: false });
    }

    return (
        <div>
            {NewAlerts}
            {loading ? <ShowLoder /> : <HideLoder />}
            <div className='row d-flex align-items-center p-1'>
                <span className='GridTitle'>Update Serial Numbers</span>
            </div>
            <div className='col-12'>
                <img src='/images/HorizontalLine.svg' className='img-fluid w-100' />
            </div>
            <div className="row p-2">
                <div className='col-1'>
                    <label className='fw-600' style={{ fontSize: '16px' }}>Import :</label>
                </div>
                <div className='col-11'>
                    <p className="text-justify" style={{ fontSize: "13px" }}>
                        To ensure that Device Serial Numbers are entered properly with data accuracy, please download our CSV template file and ensure your columns match the template before you import your device serial numbers into the system.
                    </p>
                    <div>
                        <label className="pb-3 ps-0" style={{ fontSize: "13px" }}>
                            <a onClick={() => downloadSampleCSV('deviceSerialNumbers', 'DeviceSerialNumbers')}
                                style={{ color: "#04ADFD", fontWeight: "600" }} className='cursor-pointer'>
                                CLICK HERE
                            </a> {" "}
                            to download the template CSV file for device serial numbers data. Please use this as a template and prepare your CSV file accordingly. Once your file is ready, use button below to browse file from your computer and click on upload button to import all data into your account.
                        </label>
                        <div className="col-12">
                            <div className='d-flex gap-3 align-items-center'>
                                <form onSubmit={(e) => ImportCSV(e)}>
                                    <input type="file" ref={InventoryRef} name="upload_file_device_serial_numbers" id="UploadFileDeviceSerialNumbers" accept='.csv' onChange={ShowFileName} />
                                    <label className='ImportInventoryBtnForimportExport buttonclssMobile1' htmlFor="UploadFileDeviceSerialNumbers"> Import Serial Numbers
                                        <img src='/images/ImportInventory.svg' className='img-fluid ps-2' />
                                    </label>
                                    {FileName.document != '' ?
                                        <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' style={{ backgroundColor: 'var(--primary-color)', color: '#fff' }} />
                                        :
                                        <input type="submit" value="Upload" className='UploadBtn buttonclssMobile' />
                                    }
                                </form>
                                {showErrorPopup.btn &&
                                    <label title='View CSV Errors' className='text-decoration-underline redText cursor-pointer' onClick={() => setShowErrorPopup({ ...showErrorPopup, modal: true })}>
                                        View Errors
                                    </label>
                                }
                            </div>
                            <div className='col-md-12 pe-0'>
                                <div className=" ps-2" style={{ fontWeight: "600", color: 'green' }}>{FileName.document}</div>
                                {FileName.error?.trim() != "" && <label className="redText">{FileName.error}</label>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MultiErrorPopup isErrorShow={showErrorPopup.modal} setErrorShow={() => setShowErrorPopup({ ...showErrorPopup, modal: !showErrorPopup.modal })} errorMsgs={csvError} />

            <hr />

            <div className='row p-2'>
                <div className='col-1'>
                    <label className='fw-600' style={{ fontSize: '16px' }}>Export :</label>
                </div>
                <div className='col-11'>
                    <p className="text-justify mb-2" style={{ fontSize: "13px" }}>
                        Would you like to export your device serial numbers data? To do so, simply click on the 'Export Device Serial Numbers' button.
                    </p>
                    <div>
                        <div className="col-12 px-0 pb-2">
                            <label className='BorderBtnForimportExport' onClick={ExportInventory}>Export Serial Numbers
                                <img src='/images/ExportInventory.svg' className='img-fluid ps-2' />
                            </label>
                        </div>

                    </div>
                    {divVisibleForExport.forUsers &&
                        <div className="row mt-3">
                            <div>Your Device Serial Numbers CSV file is now ready for download. Please click the button below to initiate the file download.</div>
                            <div className="col-12 mt-2">
                                <label style={{ fontSize: "12px", color: "#04ADFD" }}>
                                    DeviceSerialNumbers.csv
                                </label>
                                <button className='SaveBtn ms-4' onClick={() => downloadCSV(InventoryDataCsv)}>Download</button>
                                <FontAwesomeIcon icon={faCircleXmark} className="cursor-pointer ps-3" onClick={RemoveUserCsv} />
                            </div>
                        </div>
                    }
                    {divVisibleForExport.forUsersNoRecord &&
                        <div className="row mt-3">
                            <div className="custom-text-danger">No Record Found!</div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
